import { Illustration } from '../Illustration/Illustration';
import { jsx as _jsx } from "react/jsx-runtime";
export const Logo = props => /*#__PURE__*/_jsx(Illustration, Object.assign({}, props));
Logo.displayName = 'Logo';